import React from 'react';
import { FiVolume2, FiVolumeX } from 'react-icons/fi';
import { playSoundEffect, setSoundEffectsEnabled, useSoundEffectsEnabled } from '../lib/sfx';

export default function SoundEffectsToggle({ className = '' }) {
  const enabled = useSoundEffectsEnabled();

  const handleToggle = () => {
    const next = !enabled;
    setSoundEffectsEnabled(next);
    if (next) {
      window.setTimeout(() => {
        playSoundEffect('softClick', { volume: 0.7 });
      }, 0);
    }
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`inline-flex items-center gap-2 rounded-full border bg-white/95 px-3 py-2 text-sm font-medium text-gray-700 shadow-sm backdrop-blur hover:bg-white ${className}`}
      aria-pressed={enabled}
      title={enabled ? 'Turn sound effects off' : 'Turn sound effects on'}
    >
      {enabled ? <FiVolume2 className="h-4 w-4" /> : <FiVolumeX className="h-4 w-4" />}
      <span>{enabled ? 'Sound FX On' : 'Sound FX Off'}</span>
    </button>
  );
}
